export const homeRoutes = {
  label: 'Início',
  labelDisable: true,
  children: [
    {
      name: 'Início',
      active: true,
      icon: 'home',
      to: '/'
    }
  ]
};
export const essentialRoutes = {
  label: '',
  children: [
    {
      name: 'Materiais',
      icon: 'puzzle-piece',
      active: true,
      to: '/all-materials'
    },
    {
      name: 'Estudos De Dosagem',
      icon: 'chart-line',
      active: true,
      to: '/dosage-study'
    },
    {
      name: 'Dosagens De Concreto',
      icon: 'wrench',
      active: true,
      to: '/concrete-dosage/list'
    },
    {
      name: 'Fornecedores',
      icon: 'folder-plus',
      active: true,
      to: '/all-suppliers'
    },
    {
      name: 'Dosagem Piloto',
      icon: 'brush',
      active: true,
      to: '/pilot-dosage'
    }
    // {
    //   name: 'Usuário',
    //   icon: 'user',
    //   to: '/usuarios',
    //   active: true
    // },
    // {
    //   name: 'Dosagem',
    //   icon: 'wrench',
    //   to: '/dosagem',
    //   active: true
    // }
  ]
};

export default [homeRoutes, essentialRoutes];
